import { c as _c } from "react/compiler-runtime";
import { Separator } from "@/components/ui/separator";
import { Skeleton } from "@/components/ui/skeleton";
export function DetailDescriptionSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mt-4 p-4" data-sentry-component="DetailDescriptionSkeleton" data-sentry-source-file="RealEstateDetailMobileSections.tsx"><Skeleton className="h-6 w-32 mb-3" data-sentry-element="Skeleton" data-sentry-source-file="RealEstateDetailMobileSections.tsx" /><Skeleton className="h-4 w-full mb-2" data-sentry-element="Skeleton" data-sentry-source-file="RealEstateDetailMobileSections.tsx" /><Skeleton className="h-4 w-full mb-2" data-sentry-element="Skeleton" data-sentry-source-file="RealEstateDetailMobileSections.tsx" /><Skeleton className="h-4 w-2/3" data-sentry-element="Skeleton" data-sentry-source-file="RealEstateDetailMobileSections.tsx" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}

// Structural building blocks for the mobile detail body. Both the real detail
// and its loading skeleton compose these so their layout can't drift.

// Centered title / price / meta column, in the px-1.5 inset the body uses.
export function DetailHeaderBlock(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="px-1.5" data-sentry-component="DetailHeaderBlock" data-sentry-source-file="RealEstateDetailMobileSections.tsx"><div className="flex flex-col items-center text-center gap-1 w-full">{children}</div></div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}

// Centered, separator-delimited row of short facts (bedrooms · area · …).
export function DetailFactsRow(t0) {
  const $ = _c(4);
  const {
    items
  } = t0;
  if (items.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== items) {
    t1 = items.map(_temp);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="flex items-center justify-center flex-wrap gap-x-3 gap-y-1 px-1.5 min-h-9 text-muted-foreground text-sm" data-sentry-component="DetailFactsRow" data-sentry-source-file="RealEstateDetailMobileSections.tsx">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}

// label / value rows list (attributes section).
function _temp(item, i) {
  return <div key={i} className="flex items-center gap-x-3">{i > 0 && <Separator orientation="vertical" className="h-4" />}{item}</div>;
}
export function DetailAttributeRows(t0) {
  const $ = _c(4);
  const {
    rows
  } = t0;
  let t1;
  if ($[0] !== rows) {
    t1 = rows.map(_temp2);
    $[0] = rows;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="mt-4 px-4 pt-4" data-sentry-component="DetailAttributeRows" data-sentry-source-file="RealEstateDetailMobileSections.tsx">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp2(r, i) {
  return <div key={i} className="flex items-center justify-between py-2.5 border-b border-border"><span className="text-sm text-muted-foreground">{r.label}</span><span className="text-sm font-medium text-foreground-heading">{r.value}</span></div>;
}